module.exports = __webpack_public_path__ + "img/4pll.2150dc9a.png";